import { emitAnalyticsEvent } from '@rover/rsdk/src/modules/Analytics';
import {
  HamburgerMenuNavBarClick,
  LenguageSelectorNavBarClick,
  OurServicesSelectServiceNavBarClick,
} from '@rover/shared/js/ssr/BaseTemplate/NavBar/analyticsEvents';
import { AnalyticsEvent } from '@rover/types/src/Analytics';
import { ServiceTypeSlug } from '@rover/types/src/ServiceType';

import { storeCrossPageAnalyticsEvent } from './fireCrossPageEvent';
import saveNavigationEvent from './saveNavigationEvent';

const ANALYTICS_EVENT_MAP: Record<
  string,
  { factory: (el: HTMLElement) => AnalyticsEvent; emit: 'cross-page' | 'same-page' }
> = {
  'hamburguer-menu-nav-click': {
    factory: () => new HamburgerMenuNavBarClick(),
    emit: 'same-page',
  },
  'our-services-select-service-nav-click': {
    factory: (el) =>
      new OurServicesSelectServiceNavBarClick({
        serviceType: (el.getAttribute('data-service-type') ?? '') as ServiceTypeSlug,
      }),
    emit: 'cross-page',
  },
  'language-selector-nav-click': {
    factory: () => new LenguageSelectorNavBarClick(),
    emit: 'cross-page',
  },
};

const applyNavigationEventClickHandlers = () => {
  const links = Array.prototype.slice.call(
    document.querySelectorAll('[data-nav-event], [data-analytics-event]')
  );
  links.forEach((link) => {
    const navEvent = link.getAttribute('data-nav-event');
    const analyticsEventKey = link.getAttribute('data-analytics-event');
    link.addEventListener('click', () => {
      if (navEvent) saveNavigationEvent({ event: navEvent });
      const entry = analyticsEventKey && ANALYTICS_EVENT_MAP[analyticsEventKey];
      if (entry) {
        if (entry.emit === 'cross-page') storeCrossPageAnalyticsEvent(entry.factory(link));
        else emitAnalyticsEvent(entry.factory(link));
      }
    });
  });
};

export default applyNavigationEventClickHandlers;
